export default function FormError({ error }) {
  if (!error) return null;

  return <small className="text-red-500 text-xs">{error}</small>;
}
